/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationMessageBase
 */
export interface NotificationMessageBase {
    /**
     * 
     * @type {string}
     * @memberof NotificationMessageBase
     */
    type: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof NotificationMessageBase
     */
    data?: { [key: string]: object; } | null;
}

export function NotificationMessageBaseFromJSON(json: any): NotificationMessageBase {
    return NotificationMessageBaseFromJSONTyped(json, false);
}

export function NotificationMessageBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationMessageBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function NotificationMessageBaseToJSON(value?: NotificationMessageBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'data': value.data,
    };
}


